import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { getPaidUserSettingsUrl } from '../../urls/getPaidUserSettingsUrl';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssignToTeamHeader = ({
  canRouteToAvailable,
  routingSource
}) => /*#__PURE__*/_jsx(AssigneeOptionContainer, {
  children: /*#__PURE__*/_jsxs(View, {
    paddingInlineStart: "100",
    paddingInlineEnd: "200",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.reassignment.assignToTeam"
    }), routingSource !== ROUTING_SOURCE.HELP_DESK && /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [canRouteToAvailable && /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.reassignment.teamSectionHelp.paragraph"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "routing-ui.reassignment.teamSectionHelp.link_jsx",
            elements: {
              Link
            },
            options: {
              external: true,
              href: getPaidUserSettingsUrl()
            }
          })
        })]
      }),
      tooltipProps: {
        minInlineSize: '280px'
      }
    })]
  })
});
AssignToTeamHeader.displayName = 'AssignToTeamHeader';
export default AssignToTeamHeader;